import React from "react";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
import Heading from "./../../atoms/Heading";

const Wrap = styled.div``;

const MainHeading = styled(Heading)`
    padding-top: 0;
    padding-bottom: 8px;
    font-size: 36px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.22;
    letter-spacing: -1.95px;

    @media (min-width: 990px) {
        margin-bottom: 24px;
        border-bottom: none;
        font-size: 48px;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.17;
        letter-spacing: -2.6px;
    }
`;

const SkeletonWrapHeading = styled.div`
    margin-top: 15px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 30px;
    border: solid 1px #e6e6e6;
    border-radius: 3px;

    span {
        margin-bottom: 15px;

        &:last-child {
            margin-top: 8px;
            margin-bottom: 0;
        }
    }
`;

function SkeletonLoader() {
    return (
        <Wrap>
            <MainHeading>Upcoming Deliveries</MainHeading>
            <SkeletonWrapHeading>
                <Skeleton height={34} width={220} />
                <Skeleton height={20} width={100} />
                <Skeleton height={24} width={260} />
                <Skeleton height={24} width={120} />
            </SkeletonWrapHeading>
        </Wrap>
    );
}

export default SkeletonLoader;
